import AblyTransmitter from "../lib/AblyTransmitter";

export const changeUser = (key, val) => ({
  type: "CHANGE_USER",
  name: key,
  new_value: val
});

/* Don't let this become NaN, undefined, etc */
const ensureVideoPositionSane = (v) => {
  return (v ? Number.parseFloat(v) : 0);
};

/* You must always send everything, so that we can grab just the last message in the Control channel from history and have everything, on startup */
export const setRoom = ({ video_url, subtitle_url, is_playing, video_position, video_position_timestamp, password, video_length }) => ({
  type: "SET_ROOM",
  video_url: video_url,
  subtitle_url: subtitle_url,
  is_playing: is_playing,
  video_position: ensureVideoPositionSane(video_position), //REFACTOR: is this the right place to enforce types?
  video_position_timestamp: video_position_timestamp,
  password: password,
  video_length: video_length
});

export const logout = () => ({
  type: "LOGOUT"
});

export const presenceJoin = (val) => ({
  type: "PRESENCE_JOIN",
  presence: val
});

export const presenceLeave = (val) => ({
  type: "PRESENCE_LEAVE",
  connection_id: val
});

export const addChat = (nick_name, message) => ({
  type: "ADD_CHAT",
  nick_name: nick_name,
  message: message
});

export const receivedAblyMessage = (message_data) => {
  return message_data.action;
};


/* We have 'redux-thunk' so we can return a function, which will then be called - and
which should then create and dispatch the action we actually want */
export const broadcastAnd = ({ nick_name, room_key, namespace, action }) => (
  (dispatch) => {
    AblyTransmitter.transmit({ nick_name: nick_name, room_key: room_key, namespace: namespace, event_name: namespace + "_action", action: action });
    dispatch(action);
  }
);

